import React from 'react';

const ShippingDeliveryPolicy = () => {
    return (
        <div className="bg-gray-100 min-h-screen flex items-center justify-center">
            <div className="max-w-3xl bg-white rounded-lg shadow-lg p-8">
                <h1 className="text-3xl font-semibold mb-6 text-center">Shipping and Delivery Policy</h1>
                <div className="text-gray-800">
                    <p className="mb-4">
                        Although our products/services do not involve shipping or physical delivery, we want to provide you with clarity
                        about our digital delivery process and the services we offer.
                    </p>
                    <p className="mb-4">
                        <strong>Digital Delivery:</strong> Our products/services are delivered digitally through our online platform or by email.
                        You will receive instructions on how to access and use the digital content upon successful completion of your order.
                    </p>
                    <p className="mb-4">
                        <strong>Delivery Time:</strong> As there is no physical shipping involved, the delivery of digital content is typically instantaneous
                        or within a short time after the order is placed and payment is confirmed.
                    </p>
                    <p>
                        <strong>Customer Support:</strong> If you encounter any issues with accessing or using the digital content, please contact our
                        customer support. We are here to assist you and ensure you have a seamless experience with our products/services.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ShippingDeliveryPolicy;
